import React, { useState } from "react";
import { Dropdown, Menu, Button } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { blockUser, deleteChat, unblockUser } from "../../../routes/Chat/chat.ducks";
import { notification } from "../../../services";
import { Chat, UserI } from "../../../typings/interfaces";
import { PageRoute } from "../../../models";
import { getIconUrl } from "../../../services/asset";
import styles from "../chatPage.scss";
import { UserReportModals } from "./UserReportModals";

type Props = {
  chatId?: string;
  user: UserI;
  otherChatParticipantInfo: {
    userId?: string;
    name?: string;
    lastReadMessageId?: string;
  };
  chat?: Chat;
  isOtherUserBlocked: boolean;
}

export const DropdownMenu = ({ chatId, user, otherChatParticipantInfo, chat, isOtherUserBlocked }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [userReportModalStatus, setUserReportModalStatus] = useState(null); // null | "warning" | "shown"


  const handleDeleteChat = () => {
    if (!chatId) return;

    dispatch(deleteChat([chatId], (success, error) => {
      if (success) {
        notification.show("Razgovor je obrisan");
        history.push(PageRoute.chats);
      } else {
        notification.showError("Greška pri brisanju razgovora");
      }
    }));
  }

  const handleToggleBlockUser = () => {
    if (!otherChatParticipantInfo) return;

    const otherUserId = (user && user.userId) === (chat && chat.senderId) ? chat.recipientId : chat.senderId;

    if (isOtherUserBlocked) {
      dispatch(unblockUser(otherUserId, (success, error) => {
        if (success) {
          notification.show(`Korisnik ${otherChatParticipantInfo.name} je odblokiran`);
        } else {
          notification.showError("Greška pri odblokiranju korisnika");
        }
      }));
    } else {
      dispatch(blockUser(otherUserId, (success, error) => {
        if (success) {
          notification.show(`Korisnik ${otherChatParticipantInfo.name} je blokiran`);
        } else {
          notification.showError("Greška pri blokiranju korisnika");
        }
      }));
    }
  }

  const handleReportClick = () => {
    setUserReportModalStatus("warning")
  }


  return (
    <React.Fragment>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="toggleBlock" onClick={handleToggleBlockUser}>
              {isOtherUserBlocked ? 'Odblokiraj korisnika' : 'Blokiraj korisnika'}
            </Menu.Item>
            <Menu.Item key="deleteChat" onClick={handleDeleteChat}>
              Obriši razgovor
            </Menu.Item>
            {chat && chat.adId && (
              <Menu.Item key="report user" onClick={handleReportClick}>
                Prijavi korisnika
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={['click']}
        placement="bottomRight"
      >
        <Button className={styles.dropdownButton}>
          <img src={getIconUrl("vertical-dots.svg")} alt="" className={styles.dropdownIcon} />
        </Button>
      </Dropdown>
      <UserReportModals
        userReportModalStatus={userReportModalStatus}
        setUserReportModalStatus={setUserReportModalStatus}
        chatId={chatId}
      />

    </React.Fragment>

  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/DropdownMenu.tsx